import { Assistant } from '../types/Assistant';

export const assistants: Assistant[] = [
  {
    id: 'coordinator',
    name: 'Coordenadora',
    icon: 'brain',
    description: 'Coordenadora de conteúdo',
    specialty: 'Coordenação e estratégia',
    role: 'Coordenadora',
    emoji: '👑',
    canTrigger: ['copy', 'social', 'analyst']
  },
  {
    id: 'copy',
    name: 'Copy',
    icon: 'pen-tool',
    description: 'Redator criativo',
    specialty: 'Criação de textos',
    role: 'Copy',
    emoji: '✍️',
    canTrigger: ['social', 'analyst']
  },
  {
    id: 'social',
    name: 'Social',
    icon: 'smartphone',
    description: 'Especialista em redes sociais',
    specialty: 'Gestão de mídias sociais',
    role: 'Social',
    emoji: '📱',
    canTrigger: ['copy', 'analyst']
  },
  {
    id: 'analyst',
    name: 'Analista',
    icon: 'bar-chart',
    description: 'Analista de dados',
    specialty: 'Análise de performance',
    role: 'Analista',
    emoji: '📊',
    canTrigger: ['copy', 'social']
  }
];

export const getAssistantById = (id: string): Assistant | undefined => {
  return assistants.find(assistant => assistant.id === id);
};